import React from 'react';
import ReferAFriendDialog from 'containers/structural/ReferAFriendDialog';
import RenewDialog from 'components/structural/RenewDialog';
import ProjectAddDialog from 'containers/pages/projects/ProjectAddDialog';
import DeleteProjectDialog from 'containers/pages/projects/DeleteDialog';
import ValidateAddressDialog from 'components/structural/ValidateAddressDialog';
import EditNameDialog from 'containers/pages/projects/EditNameDialog';
import TaskSchedulerDialog from 'containers/structural/TaskSchedulerDialog';
import StatusSheet from 'components/common/StatusSheet';
import ResetScrollUponNav from 'components/structural/ResetScrollUponNav';
import Dialogs from 'components/common/Dialogs';
import GlobalStyles from 'components/styles/GlobalStyles';

const GlobalComponents = () => {
	return (
		<>
			<GlobalStyles />
			<Dialogs />
			<RenewDialog />
			<ResetScrollUponNav />
			<ProjectAddDialog />
			<DeleteProjectDialog />
			<EditNameDialog />
			<ReferAFriendDialog />
			<TaskSchedulerDialog />
			<StatusSheet />
			<ValidateAddressDialog />
		</>
	);
};

export default GlobalComponents;
